import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { UtilService } from '../services/util.service';
import {
    ApplicationControl
} from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class ApplicationControlService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private utilService: UtilService) {
    }

    public getApplicationControls() {
        //return this.http.get<ApplicationControl[]>(this.baseUrl + 'api/ApplicationControl/GetApplicationControls');
        var key: string = "ApplicationControls";
        var url: string = this.baseUrl + "api/ApplicationControl/GetApplicationControls";
        return this.utilService.obs(key, url) as Observable<ApplicationControl[]>;
    }

    public getApplicationControlsByAppName(appName: string, isCache: boolean = true) {
        if (!isCache) {
            return this.http.get<ApplicationControl[]>(this.baseUrl + 'api/ApplicationControl/GetApplicationControlsByAppName/?appName=' + appName);
        }
        else {
            var key: string = "ApplicationControlsByName=" + appName;
            var url: string = this.baseUrl + "api/ApplicationControl/GetApplicationControlsByAppName/?appName=" + appName;
            return this.utilService.obs(key, url) as Observable<ApplicationControl[]>;
        }
    }

    //private obs(key: string, url: string): Observable<ApplicationControl[]> {
    //    var json = localStorage.getItem(key);
    //    if (json != null) {
    //        var obj = JSON.parse(json) as ApplicationControl[];
    //        return of<ApplicationControl[]>(obj);
    //    }
    //    else {
    //        this.http.get<ApplicationControl[]>(url).subscribe(result => {
    //            json = JSON.stringify(result);
    //            localStorage.setItem(key, json);
    //        });
    //        return this.http.get<ApplicationControl[]>(url);
    //    }
    //}

    //private xobs(json: string): Observable<ApplicationControl[]> {
    //    var obj = JSON.parse(json) as ApplicationControl[];
    //    return of<ApplicationControl[]>(
    //        obj
    //    );
    //}
}
